import { defineMessages } from "../core"

export const app = defineMessages({
  en: {
    "shell.dummyChatsFailed": "Dummy chats could not be created.",
    "shell.moveConversationFailed": "Conversation could not be moved. Please try again.",
    "shell.openConversations": "Open conversations",
    "shell.conversations": "Conversations",
    "shell.resizeConversationList": "Resize conversation list",
    "shell.meetingsInRange": "Meetings in this period",
    "header.guide": "Guide and what's new",
    "header.language": "Language",
    "header.langEnglish": "English",
    "header.langGerman": "Deutsch",
    "header.guideNew": "Guide and what's new (new entries)",
    "header.toggleTheme": "Toggle theme",
    "header.signOut": "Sign out",
    "login.signIn": "Sign in with Microsoft",
    "error.somethingWentWrong": "Something went wrong",
    "error.reload": "Reload",
    "conversations.deleteFailed": "Conversation could not be deleted. Please try again.",
    "projects.loadFailed": "Projects could not be loaded. Please try again.",
    "projects.maxCount": "You can create up to 100 projects.",
    "projects.nameLength": "Project names must be between 1 and 80 characters.",
    "projects.instructionsLength": "Project instructions must be 8,000 characters or fewer.",
    "engine.graph": "Standard search",
    "engine.copilot": "Copilot semantic",
    "searching.projects": "AI Projects",
    "searching.tools": "documents",
    "sources.files": "Files",
    "sources.mail": "Mail",
    "sources.chat": "Chats",
  },
  de: {
    "shell.dummyChatsFailed": "Dummy-Chats konnten nicht erstellt werden.",
    "shell.moveConversationFailed": "Die Unterhaltung konnte nicht verschoben werden. Bitte erneut versuchen.",
    "shell.openConversations": "Unterhaltungen öffnen",
    "shell.conversations": "Unterhaltungen",
    "shell.resizeConversationList": "Größe der Unterhaltungsliste ändern",
    "shell.meetingsInRange": "Meetings in diesem Zeitraum",
    "header.guide": "Anleitung und Neuigkeiten",
    "header.language": "Sprache",
    "header.langEnglish": "English",
    "header.langGerman": "Deutsch",
    "header.guideNew": "Anleitung und Neuigkeiten (neue Einträge)",
    "header.toggleTheme": "Design wechseln",
    "header.signOut": "Abmelden",
    "login.signIn": "Mit Microsoft anmelden",
    "error.somethingWentWrong": "Etwas ist schiefgelaufen",
    "error.reload": "Neu laden",
    "conversations.deleteFailed": "Die Unterhaltung konnte nicht gelöscht werden. Bitte erneut versuchen.",
    "projects.loadFailed": "Projekte konnten nicht geladen werden. Bitte erneut versuchen.",
    "projects.maxCount": "Es können höchstens 100 Projekte erstellt werden.",
    "projects.nameLength": "Projektnamen müssen zwischen 1 und 80 Zeichen lang sein.",
    "projects.instructionsLength": "Projektanweisungen dürfen höchstens 8.000 Zeichen lang sein.",
    "engine.graph": "Standardsuche",
    "engine.copilot": "Copilot semantisch",
    "searching.projects": "KI-Projekte",
    "searching.tools": "Dokumente",
    "sources.files": "Dateien",
    "sources.mail": "E-Mails",
    "sources.chat": "Chats",
  },
})
